import { X } from "lucide-react";

export const initWeights = (types = []) => Object.fromEntries(types.map((t) => [t, ""]));
export const toWeights = (v) => Object.fromEntries(Object.entries(v).filter(([, x]) => x !== "").map(([k, x]) => [k, Number(x)]));
const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");
const money = (n) => `₹${(Math.round(n * 100) / 100).toLocaleString("en-IN")}`;

export const calcTotal = (value, materials) => {
  const price = Object.fromEntries(materials.map((m) => [m.name, m.price || 0]));
  return Object.entries(value).reduce((s, [k, v]) => s + (Number(v) || 0) * (price[k] || 0), 0);
};

export const WeightsForm = ({ value, onChange, materials = [] }) => {
  const price = Object.fromEntries(materials.map((m) => [m.name, m.price || 0]));
  const rows = Object.keys(value);
  const extra = materials.filter((m) => !rows.includes(m.name));
  const total = calcTotal(value, materials);
  return (
    <div className="space-y-2" data-testid="weights-form">
      {rows.map((t) => (
        <div key={t} className="flex items-center gap-2 rounded-xl bg-[#F4F8F5] p-2">
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-[#0D3B2B]">{t}</p>
            <p className="text-[11px] text-[#7B968B]">{money(price[t] || 0)}/kg · {money((Number(value[t]) || 0) * (price[t] || 0))}</p>
          </div>
          <input type="number" inputMode="decimal" min="0" step="0.1" placeholder="kg" value={value[t]} data-testid={`weight-input-${slug(t)}`}
            onChange={(e) => onChange({ ...value, [t]: e.target.value })} className="h-11 w-24 rounded-xl border border-[#D2E0D8] bg-white px-3 text-base" />
          <button type="button" onClick={() => { const { [t]: _, ...rest } = value; onChange(rest); }} className="p-1 text-[#7B968B]" data-testid={`weight-remove-${slug(t)}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
      {!!extra.length && (
        <select value="" onChange={(e) => e.target.value && onChange({ ...value, [e.target.value]: "" })} data-testid="weight-add-material"
          className="h-11 w-full rounded-xl border border-dashed border-[#2E9E6B] bg-white px-3 text-sm font-semibold text-[#2E9E6B]">
          <option value="">+ Add another material</option>
          {extra.map((m) => <option key={m.name} value={m.name}>{m.name} ({money(m.price || 0)}/kg)</option>)}
        </select>
      )}
      <div className="flex items-center justify-between rounded-xl bg-[#0D3B2B] px-4 py-3 text-white">
        <span className="text-sm font-semibold">Total to pay customer</span>
        <span className="font-display text-2xl font-extrabold" data-testid="weights-total">{money(total)}</span>
      </div>
    </div>
  );
};
